import { Search } from "react-feather";
import { Col, Form, FormGroup, Input } from 'reactstrap';
import { H3 } from "../../../AbstractElements";
import RatioImage from "../../../CommonElements/RatioImage";
import { KnowledgebaseHelpQue, KnowledgebasePlaceholder } from "../../../Constant";
import { dynamicImage } from "../../../Service/DynamicImage";

const KnowledgebaseHelp = () => {
  return (
    <Col xs="12">
      <div className="knowledgebase-bg">
        <RatioImage className="bg-img-cover bg-center" src={dynamicImage("knowledgebase/bg_1.jpg")} alt="looginpage"/></div>
      <div className="knowledgebase-search">
        <div>
          <H3 className="mb-3">{KnowledgebaseHelpQue}</H3>
          <Form onSubmit={(e)=>e.preventDefault()} className="form-inline" method="get">
            <FormGroup className="w-100 m-0">
              <Search/>
              <Input className="form-control-plaintext w-100" type="text" placeholder={KnowledgebasePlaceholder}/>
            </FormGroup>
          </Form>
        </div>
      </div>
    </Col>
  );
};

export default KnowledgebaseHelp;
